export default __webpack_public_path__ + "static/undp-logo.d6bb7b06.svg";